import { getCulture } from "CMS/utils";
import { Modal } from "components";
import LanguageDropdown from "components/dropdowns/reactselect/LanguageDropdown";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React from "react";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  onCreated: (invitationTemplateId: number) => void;
  type: server.dto.MessageTemplateTypes;
}

export const NewInvitationTemplateModal = (props: Props) => {
  const currentUser = useCurrentUser();
  const [value, setValue] = React.useState<string>("");
  const [language, setLanguage] = React.useState(serverReference.languages.find(l => l.value === getCulture(currentUser.culture).language));

  const submit = () => {
    return window.CoreApi.MessageTemplate.Create({
      title: value,
      expectAttachment: false,
      basicTemplate: false,
      type: props.type,
      language: language.value
    })
  }

  const onSuccess = (invitationTemplateId: number) => {
    props.onCreated(invitationTemplateId);
  }

  return <Modal
    isOpen={props.isOpen}
    title={props.title}
    handleClose={props.onClose}
    width="tiny"
  >
    <EditSectionTemplate
      submit={submit}
      noPanels
      onSuccess={onSuccess}
      sections={[{
        key: "invitationTemplate",
        type: "regular",
        title: props.title,
        fields: [{
          key: "title",
          label: RESX.GeneralLabels.Name,
          renderEditNew: () => <RequiredTextInput
            maxLength={serverReference.constants.messageTemplate.maxTitleLength}
            value={value}
            onChange={(v) => setValue(v)}
            validatorKey="title"
          />
        }, {
          key: "language",
          label: RESX.Language.resxLanguage,
          renderEditNew: () => <LanguageDropdown
            value={language}
            onChange={setLanguage}
          />
        }]
      }]}
    />
  </Modal>
}
